import { TaskCreate } from "./TaskCreate";
import TaskList from "./TaskList";
import { TaskShow } from "./TaskShow";

export default {
  list: TaskList,
  show: TaskShow,
  create: TaskCreate,
};
